import { useState } from 'react';

import { Box, Button, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from '@bonusly/design-system';

import { FormSection } from '../../components/form/form-section';
import { NotificationsSettingsForm } from './notifications-settings-form';
import { NotificationSettings } from './types';
import { initializeSettings } from './utils/notification-settings-mapper';

// Stubbed API response - will be replaced with actual API call
const getStubbedSettings = (): NotificationSettings => {
	// Initialize with all possible settings based on NOTIFICATION_CONFIG
	// This ensures all topics and channels (including microsoftTeams) are included
	const settings = initializeSettings();
	
	// For demo purposes, enable a few settings
	return settings.map(setting => {
		if (setting.topicId === 'posts' && setting.channel === 'email') {
			return { ...setting, enabled: true };
		}
		return setting;
	});
};

export const UserSettings = () => {
	// Stubbed initial settings - will be replaced with useQuery
	// Using useState to ensure stable reference across renders
	const [initialSettings] = useState<NotificationSettings>(() => getStubbedSettings());

	// Local state to track current form values
	const [currentSettings, setCurrentSettings] = useState<NotificationSettings | null>(null);

	const handleSave = () => {
		if (currentSettings) {
			// TODO: Replace with actual API mutation
			console.log('Saving settings:', currentSettings);
			// Future: mutate(currentSettings, { onSuccess: () => showSuccessToast() })
		}
	};

	return (
		<Flex justify="center" py={8}>
			<FormSection px={4} py={6} width="70%">
				<Tabs variant="line">
					<TabList mb={4} borderBottom="none">
						<Tab>Basic</Tab>
						<Tab>Notifications</Tab>
						<Tab>Services</Tab>
					</TabList>

					<TabPanels>
						<TabPanel>
							<Box>Coming soon!</Box>
						</TabPanel>
						<TabPanel px={0}>
							<NotificationsSettingsForm initialSettings={initialSettings} onChange={setCurrentSettings} />
						</TabPanel>
						<TabPanel>
							<Box>Coming soon!</Box>
						</TabPanel>
					</TabPanels>
				</Tabs>

				<Box pl={4}>
					<Button colorScheme="primary" size="md" mr="auto" display="block" onClick={handleSave}>
						Save changes
					</Button>
				</Box>
			</FormSection>
		</Flex>
	);
};
